/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineLockClosed, HiOutlinePencil } from "react-icons/hi";

import ListPage from "../../layout/ListPage";
import type { Action, Column } from "../../ui";
import { useStaticContext } from "../../context/StaticContext";
import { pushOnePrivacy } from "../../lib/sysNavigation/SysNavigation";

type PrivacyRow = {
  privacy_id: number | string;
  description?: string;
  [key: string]: unknown;
};

const editRoute = "/privacy/edit";

const stripHtml = (html: string): string => {
  if (typeof document === "undefined") return html.replace(/<[^>]*>/g, " ");
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return (tmp.textContent ?? tmp.innerText ?? "").replace(/\s+/g, " ").trim();
};

const Overview: React.FC = () => {
  const navigate = useNavigate();
  const { privacy, fetchPrivacy } = useStaticContext() as any;

  useEffect(() => {
    if (!privacy) fetchPrivacy();
  }, [privacy]);

  const rows = useMemo<PrivacyRow[] | null>(() => {
    if (!Array.isArray(privacy)) return null;
    return privacy as PrivacyRow[];
  }, [privacy]);

  const columns: Column<PrivacyRow>[] = [
    {
      header: "Preview",
      cell: (row) => {
        const text = row.description ? stripHtml(row.description) : "";
        return text ? (
          <p className="line-clamp-3 text-gray-700">{text}</p>
        ) : (
          <span className="text-gray-400">No content yet.</span>
        );
      },
    },
  ];

  const rowActions = (row: PrivacyRow): Action[] => [
    {
      label: "Edit",
      icon: <HiOutlinePencil className="h-3.5 w-3.5" />,
      onClick: () => {
        pushOnePrivacy(row);
        navigate(editRoute);
      },
    },
  ];

  return (
    <ListPage<PrivacyRow>
      title="Privacy Policy"
      subtitle="Sections of the public Privacy Policy page."
      icon={<HiOutlineLockClosed className="h-5 w-5" />}
      rows={rows}
      columns={columns}
      rowKey={(r) => r.privacy_id}
      rowActions={rowActions}
      empty="No privacy sections yet."
    />
  );
};

export default Overview;
